require('bootstrap/dist/js/bootstrap.min');
require('jquery-sortable/source/js/jquery-sortable-min');
require('slick-carousel/slick/slick.min');
require('parsleyjs/dist/parsley.min');
require('./parsley/i18n/de');
require('./mmenu-js-master/src/mmenu');
require('./notifications');
require('./jquery.form');
require('./loginForm');
require('select2/dist/js/select2.min');
require('./nwt.mailobfuscation');
require('./residentialareaMap');
require('./youtubeVideo');
require('./youtubePlaylist');
require('./jquery.doubleTapToGo');
require('./jquery.hoverIntent');
require('./myAblNotificationGroups');
require('imagelightbox/dist/imagelightbox.min');
require('lazysizes/plugins/respimg/ls.respimg');
require('lazysizes/plugins/parent-fit/ls.parent-fit.min');
require('lazysizes/plugins/bgset/ls.bgset.min');
require('lazysizes/lazysizes.min');
import Stickybits from 'stickybits';

window.AblCh = window.AblCh || {};

document.addEventListener(
  "DOMContentLoaded", () => {

    const $body = $('body');
    const stickyHeader = new Stickybits('#head-wrap', {useStickyClasses: true});

    // modal backdrop for search and login toggles
    // hide modal backdrop and close the toggles when backdrop is clicked
    const $modalBackdrop = $('<div id="modal-backdrop"></div>');
    $modalBackdrop.on('click', function() {
      $('#toggleSearch').removeClass('selected');
      $('#toggleLogin').removeClass('selected');
      $('#header-accordion > div').hide();
      $modalBackdrop.hide();
      if($menuBarTopics.length > 0) {
        $topicsBackdrop.fadeOut();
      }
    });
    $body.append($modalBackdrop);

    // blocker for topic navigation (magazine pages only
    // hide modal backdrop and close the toggles when backdrop is clicked
    const $topicsBackdrop = $modalBackdrop.clone();
    const $menuBarTopics = $('#menu-topic-wrap');
    if($menuBarTopics.length > 0) {
      $menuBarTopics.on('click', function() {
        $('#toggleSearch').removeClass('selected');
        $('#toggleLogin').removeClass('selected');
        $('#header-accordion > div').hide();
        $modalBackdrop.hide();
        $topicsBackdrop.fadeOut();
      });
      $topicsBackdrop.attr('id', 'backdrop-topics');
      $menuBarTopics.append($topicsBackdrop);
    }

  // open agenda item by has
  if (location.hash !== null && location.hash !== "") {
    $(location.hash + ".collapse").collapse("show");
  }

  // update agenda item hash for direct linking
  document.querySelectorAll( 'a[data-toggle="collapse"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      let identifierHash = this.getAttribute('data-target');
      window.location.hash = identifierHash;
    });
  });

    // (single) images lightbox for DL.Gallery template/theme
    // DistributionPackages/Visol.AblCh/Resources/Private/Templates/NodeTypes/Gallery/Themes/LightboxGallery/LightboxGallery.html
    // https://marekdedic.github.io/imagelightbox/
    $('a[data-imagelightbox="dl-gallery-lightbox"]').imageLightbox({
        overlay: true,
        caption: true,
    });

    // magazine puzzlePagae lightboxes
    $('a[data-imagelightbox="findsachen"]').imageLightbox({
        overlay: true,
        caption: true,
        button: true,
        quitOnDocClick: false
    });

    $('a[data-imagelightbox="findsachen-solution"]').imageLightbox({
        overlay: true,
        caption: true,
        button: true,
        quitOnDocClick: false
    });

    // init bootstrap tooltips i.e. formBuilder backend infos
    $('[data-toggle="tooltip"]').tooltip()

    // toggle pw visibility
    $(".show-hide-password-button").on('click', function(event) {
      event.preventDefault();
      var $fieldWrap = $(this).parent();
      var $passwordField = $($fieldWrap).find('input');
      var $icon = $($fieldWrap).find('i');

      if($($passwordField).attr("type") == "text"){
        $($passwordField).attr('type', 'password');
        $($icon).addClass( "abl-icon-eye-off" );
        $($icon).removeClass( "abl-icon-eye" );
      } else if($($passwordField).attr("type") == "password"){
        $($passwordField).attr('type', 'text');
        $($icon).removeClass( "abl-icon-eye-off" );
        $($icon).addClass( "abl-icon-eye" );
      }
    });

    if (typeof Mmenu !== 'undefined') {
      // Check if the #menu-mobile element exists
      const menuMobile = document.getElementById('menu-mobile');
      if (menuMobile) {
        // Initialize mmenu

        // setup custom de strings, in case we need to change the wording
        const customDe = {
          'cancel': 'x',
          'Cancel searching': 'Suche abbrechen',
          'Clear searchfield': 'Suchfeld löschen',
          'No results found.': 'Keine Ergebnisse gefunden.',
          'Search': 'Suche',
        }
        Mmenu.i18n(customDe, 'ch' );

        const mmenu = new Mmenu( menuMobile, {
            "slidingSubmenus": false,
            "offCanvas": {
              "position": "left"
            },
            "theme": "white",
              "navbar": {
                add: false,
                title: "abl.ch",
                titleLink: "anchor"
              },
              "navbars": [
              {
                "position": "top",
                "content": ['close','<div id="mobile-top-title">title</div>','<div></div>'],
              },
              {
                "position": "bottom",
                "content": [ '<div id="mobile-meta-bottom">servicebutton</div>' ]
              },
            ],
            "searchfield": {
              "title": "Suchen",
              "splash": "Suchen Sie nach Menüpunkten",
              "placeholder": "Suchbegriff",
              "noResults": "Kein passender Menüpunkt gefunden. Probieren Sie es über die normale Suchfunktion.",
            },
            hooks: {
              // offCanvas api: https://mmenujs.com/docs/core/off-canvas.html#h4
              "open:after": ( panel ) => {
                $modalBackdrop.fadeOut();
                $topicsBackdrop.fadeOut();
                $('#toggleSearch').removeClass('selected');
                $('#toggleLogin').removeClass('selected');
                $('#header-accordion > div').hide();
                //AblCh.removeTopicsSubmenu();
              }
            }
          },
          {
          language: "ch",
          searchfield: {
            add: false,
            cancel: true,
            clear: false
            }
        });

        // move hidden metaMenu to left mmenu. 2nd metaMenu in header is always present but hidden
        const menuMetaBottom = document.getElementById('menu-meta-mobile');
        const menuBottomTarget = document.getElementById('mobile-meta-bottom');
        menuBottomTarget.innerHTML = menuMetaBottom.innerHTML;

        // get mobile logo from dom and move to mmenu title position
        const logoTopMobile = document.getElementById('logo-top-mobile');
        const logoTopMobileTarget = document.getElementById('mobile-top-title');
        logoTopMobileTarget.innerHTML = logoTopMobile.innerHTML;

      } else {
        console.error("#menu-mobile element not found");
      }
    } else {
      console.error("Mmenu library not loaded");
    }

    // show page up link on scroll
    if ( $( "#page-up-link" ).length ) {
        var pageUpLink = $('#page-up-link');
        $(window).scroll(function() {
            if ($(window).scrollTop() > 300) {
                pageUpLink.addClass('fixed');
            } else {
                pageUpLink.removeClass('fixed');
            }
        });
    }

    // Initialize the sliders
    AblCh.initializeSlickSlider();
    AblCh.initializeDlGallerySlider();
    // Initialize main menu
    AblCh.initializeDropDownMenu();

    // Reload content area when a new Node with class "slider-item" was injected
    document.addEventListener('Neos.NodeCreated', function(event) {
        var element = event.detail.element;
        if (element.classList.contains('slider-item')) {
            Typo3Neos.Content.reloadPage();
        }
    }, false);

    // Initialize slider on (re-)load page
    document.addEventListener('Neos.PageLoaded', function(event) {
        AblCh.initializeSlickSlider();
        AblCh.initializeDropDownMenu();
        AblCh.initializeDlGallerySlider();
    }, false);

    // Houston we have a form
    if ( $( ".neos-form" ).length ) {
      // Initialize parsley
      $('.neos-form').parsley();

        // init character counter, set on maxlength of textarea and input=text
        if( $( ".neos-form .charcounter" ).length ) {
          $('.neos-form .charcounter').each(function (index, element) {
            var uid = $(element).data('field-uid');
            $('#' + uid).keyup(function() {
              var counter = $('#' + uid).parent().find(' .charcounter');
              var characterCount = parseInt($(this).val().length);
              var  current = $(counter).find('.current');
              var  maximum = parseInt($(counter).find('.maximum').text());
              current.text(characterCount);
              current.removeClass('maxlength-alert');
              if(characterCount == maximum){
                current.addClass('maxlength-alert');
              }
            });
          });
        }
    }

    // used in FormBuilder RedirectFinisher
    if ( $( ".form-countdown" ).length ) {
      var pause = $('.form-countdown').data('delay-countdown');
        var redirectTimer = setInterval(function () {
          pause -= 1;
          if(pause > -1){
            $('.form-countdown').html(pause);
          }
        },1000);
    }

    let alreadyScrolledDown = false;

    // Scroll to form submit success if present
    if ($('.neos-form-success').length) {
      alreadyScrolledDown = true;
      AblCh.scrollToElement('.neos-form-success');
    }
    if ($('.help-inline').length && !alreadyScrolledDown) {
      alreadyScrolledDown = true;
      AblCh.scrollToElement('.help-inline');
    }
    if ($('.neos-message-wrapper').length && !alreadyScrolledDown) {
      alreadyScrolledDown = true;
      AblCh.scrollToElement('.neos-message-wrapper');
    }
    if ($('.updateNotificationGroupsFlashMessages').length && !alreadyScrolledDown) {
      AblCh.scrollToElement('.updateNotificationGroupsFlashMessages');
    }

    $(".js-example-basic-multiple").select2();

    $("#addToApplication").click(function() {
        $("#applicationSelector").slideDown();
    });

    $body.on('click', '#toggleSearch, #toggleLogin', function(e) {
        e.preventDefault();
        var selectTab = $(this).data('tab');
        if($(this).hasClass('selected')){
            $('#'+selectTab).hide();
            $('#password').prop('disabled', true);
            $(this).removeClass('selected');

            $modalBackdrop.fadeOut();
            if($menuBarTopics.length > 0) {
              $topicsBackdrop.fadeOut();
            }
            return false;
        }
        // revert state if set by #showResetPass
        $('#login-form').show();
        $('#resetPassword').removeClass('in');

        $('#toggleSearch').removeClass('selected');
        $('#toggleLogin').removeClass('selected');
        $(this).addClass('selected');
        $('#password').prop('disabled', false);

        $('#header-accordion > div').each(function (index, element) {
            // hide all, then show selected
            $(element).hide();
            if($(element).attr('id') == selectTab){
                $(element).toggle();
                // focus first input field
                $('#'+selectTab+' input:first').focus();
            };
        });

        $modalBackdrop.show();
        if($menuBarTopics.length > 0) {
          $topicsBackdrop.show();
        }
    });

    // additonal binding on links defined as '#trigger-show-login'
    $('a[href="#trigger-show-login"]').on('click', function (e) {
      e.preventDefault();
      $('#toggleLogin').click();
    });

    /**
     * Expand collapsed forms to display username/password change error messages
     */
    if($('.validation__errors').length) {
        var form = $('.validation__errors').closest('.collapse');
        form.collapse('show');
        AblCh.scrollToElement('#' + form.attr('id'));
    }
    if($('.updatePasswordFlashMessages').length) {
        var form = $('.updatePasswordFlashMessages').closest('.collapse');
        form.collapse('show');
        AblCh.scrollToElement('#' + form.attr('id'));
    }

    /**
     * Schadenmeldung
     */
    if ($('#damagereport-form').length) {
        var geraet = '';
        $('#damagereport-form-make_model').parent().parent().hide();
        $('#damagereport-form-serialnumber').parent().parent().hide();
        $('#damagereport-form-infoserial').hide();

        $('#damagereport-form-machine').on('change',function (){
            geraet = $(this).val()
            if(geraet != ''){
                $('#damagereport-form-make_model').parent().parent().show();
                $('#damagereport-form-serialnumber').parent().parent().show();
            }
            else {
                $('#damagereport-form-make_model').parent().parent().fadeOut();
                $('#damagereport-form-serialnumber').parent().parent().fadeOut();
            }
        });

        if($('#damagereport-form-machine').val() != ''){
            $('#damagereport-form-make_model').parent().parent().show();
            $('#damagereport-form-serialnumber').parent().parent().show();
        }

        $(' <button class="btn btn-sm serial-info">wo finde ich diese Angabe?</button>').appendTo('label[for="damagereport-form-make_model"], label[for="damagereport-form-serialnumber"]');
        $('label[for="damagereport-form-make_model"], label[for="damagereport-form-serialnumber"]').on('click', function () {
            $('#damagereport-form-infoserial').toggle();
            return false;
        });
    }

    /**
     * Form with timeslot
     */
    if ($(".form-control-abl-timeslot").length > 0) {
        var InfodaysAvailable = [];
        $(".form-control-abl-timeslot option").each(function () {
            InfodaysAvailable[this.value] = $(this).data('available-participants');
            if(InfodaysAvailable[this.value] < 1){
                $(this).attr('disabled','disabled').css('text-decoration','line-through').css('color','#ccc');
            }
        });
        $(".form-control-abl-timeslot").on('change', function () {
            $('.form-control-abl-participants').children('option:not(:first)').remove();
            if(InfodaysAvailable[this.value] < 5){
                var i = 0;
                while (i < InfodaysAvailable[this.value]) {
                    i++;
                    var personLabel = i < 2 ? " Person" : " Personen";
                    $('.form-control-abl-participants').append($("<option></option>")
                        .attr("value",i)
                        .text(i + personLabel));
                }
            }
            else {
                var i = 0;
                while (i < 5) {
                    i++;
                    var personLabel = i < 2 ? " Person" : " Personen";
                    $('.form-control-abl-participants').append($("<option></option>")
                        .attr("value",i)
                        .text(i + personLabel));
                }
            }
        })
    }

    /**
     * Hi3 Non member application
     */
    if ($("form#hi3-non-member-application").length > 0) {

        parsleyFieldValidators = [];
        rentalObjectSortedIds = [];

        AblCh.showFormValidationSummary('hi3-non-member-application');

        // 'remember' all parsley validators
        $("form#hi3-non-member-application").find('input, select, textarea, checkbox, radio').each(
          function () {
              var field = $(this);
              var fieldId = field.attr('id');
              var fieldValidators = [];

              $.each(this.attributes, function () {
                  // this.attributes is not a plain object, but an array
                  // of attribute nodes, which contain both the name and value
                  if (this.specified) {
                      if (this.name.startsWith('data-parsley')) {
                          //console.log(this.name, this.value);
                          fieldValidators.push(this)
                      }
                  }
              });

              if (fieldId != undefined) {
                  parsleyFieldValidators[fieldId] = fieldValidators;
              }
          });


        // initialy disable validation of fieldsets hidden by css
        AblCh.initConditionalFormSectionAndValidation();

        // show hide applicant sections according number of applicants
        $("#hi3-non-member-application-numberOfApplicants").on('change', function () {
            AblCh.initConditionalFormSectionAndValidation();
        });

        if (AblCh.rentalObjects) {

            var applicationItems = AblCh.rentalObjects;

            if (applicationItems.length > 0) {
                for (i = 0; i < applicationItems.length; i++) {
                    var selObjPos = i + 1; // we start with 1
                    applicationItem = applicationItems[i];
                    var objNumber = applicationItem.position;
                    var objTitle = applicationItem.title;
                    var objRealEstateObjectAbacusObjectNumber = applicationItem.realEstateObject.abacusObjectNumber;

                    if ($("ol#rentalObjectsSorted-list").length > 0) {
                        var rentalObjectHiddenString = objNumber + ', ' + objTitle + ' (' + objRealEstateObjectAbacusObjectNumber + ')';

                        $rentalObjectSortingList = $("ol#rentalObjectsSorted-list");

                        var ratingHearts = '<div class="myrating">' + AblCh.formatHearts(i) + '</div>';

                        $rentalObjectSortingList.append('<li class="rental-object" data-id="' + objNumber + '" data-title="' + objTitle + '" data-real-estate-object-abacus-object-number="' + objRealEstateObjectAbacusObjectNumber + '">' + objTitle + ratingHearts + '</li>');
                        rentalObjectSortedIds.push(rentalObjectHiddenString);

                        $("#hi3-non-member-application-rentalObject-" + selObjPos).val(
                          rentalObjectHiddenString);
                    }
                }

                // https://johnny.github.io/jquery-sortable/
                $rentalObjectSortingList.sortable({
                    onDrop: function ($item, container, _super) {
                        rentalObjectSortedIds = [];

                        // update ol and hearts

                        $("ol#rentalObjectsSorted-list li").each(function (index) {
                            var $this = $(this);
                            var rentalObjectHiddenString = $this.data('id') + ', ' + $this
                            .data('title') + ' (' + $this.data('real-estate-object-abacus-object-number') + ')';
                            rentalObjectSortedIds.push(rentalObjectHiddenString);

                            // update hidden fields
                            var objectFieldId = "#hi3-non-member-application-rentalObject-" + parseInt(
                            index + 1);
                            $(objectFieldId).val(rentalObjectHiddenString);

                            var ratingHearts = AblCh.formatHearts(index);
                            $(this).find('div.myrating').html(ratingHearts);
                          }
                        );
                        // update hidden texarea
                        $("#hi3-non-member-application-rentalObjectsSorted").val(
                          rentalObjectSortedIds.join("\r\n"));

                        _super($item, container);
                    }
                });
                $("#hi3-non-member-application-rentalObjectsSorted").val(rentalObjectSortedIds.join(
                  "\r\n"));
            }
        } else {
            $("form#hi3-non-member-application #info-rentalobjects").html(
              'Bitte wählen Sie Ihre Wunschwohnung unter <a href="https://ws.himmelrich3.ch/">himmelrich3.ch</a>.');
        }
    }



});

AblCh = $.extend(AblCh, {

    scrollToElement: function(elementId) {
      if($(elementId).length) {
        $('html, body').animate({
          scrollTop: $(elementId).offset().top - 200
        }, 1000);
      }
    },

    toggleFileArchiveYears: function(button, year) {
        $('#year'+year+' ul.months').slideToggle();
        //$(button).toggleClass('expanded');
        $('#year'+year+' div').toggleClass('expanded');
    },

    preventMultiSubmit: function(element) {
        var $submitButton = $(element);
        var initialText = $submitButton.data('initialtext');
        var submitCount = $submitButton.data('submitcount');

        $submitButton.html('bitte warten...')
        // release button after a while
        setTimeout( function () {
          $submitButton.prop('disabled',false);
          $submitButton.removeClass('clicked');
          $submitButton.html(initialText);
        }, 6000);
    },

    initConditionalFormSectionAndValidation: function() {
        var personCounter = 1;
        var numberOfApplicants = $("#hi3-non-member-application-numberOfApplicants").val();
        var bootstrapColClass = 'col-sm-12';

        $("form#hi3-non-member-application > .applicants").each(function () {
            ++personCounter;

            if(numberOfApplicants > 2) {
                bootstrapColClass = 'col-sm-6';
            }

            // remove col classes and add new ones according number of persons
            // multicolumns on 1-3 persons fieldsets
            $(this).removeClass('col-sm-6');
            if(personCounter < 4){
                $(this).removeClass('col-sm-12');
                $(this).addClass(bootstrapColClass);
            }

            // show hide person 1-3
            if(personCounter <= numberOfApplicants){
                AblCh.showOrHideFormSectionAndValidation($(this).attr('id'),'show');
            }
            else {
                AblCh.showOrHideFormSectionAndValidation($(this).attr('id'),'hide');
            }

            // show hide field 4+ persons
            if(numberOfApplicants < 4){
                AblCh.showOrHideFormSectionAndValidation("hi3-non-member-application-additionalPersons",'hide');
            }
            else {
                AblCh.showOrHideFormSectionAndValidation("hi3-non-member-application-additionalPersons",'show');
            }
        });

        // init parsley
        $("form#hi3-non-member-application").parsley();

    },

    /**
     * show/hide form section (fieldset) and activate/deactivate
     * parsley validation of the contained fields
     */
    showOrHideFormSectionAndValidation: function(sectionId, mode) {
        var $section = $('#' + sectionId);

        // remove validators of fieldset
        $section.find('input, select, textarea, checkbox, radio').each(function () {
            var $field = $(this);
            storedValidators = parsleyFieldValidators[$field.attr('id')];
            var $label = $field.parent().parent().find('label');

            $(storedValidators).each(function () {
                if(mode == 'hide') {
                    $section.fadeOut();
                    $field.removeAttr(this.name);
                    $label.removeClass('mandatory');
                }
                else {
                    $section.fadeIn();
                    $field.attr(this.name,this.value);
                    if(this.name == 'data-parsley-required' && this.value && 'true') {
                        $label.addClass('mandatory');
                    }
                }
            });
        });
    },

    /**
     * calculating hearts according favourite position
     */
    formatHearts: function(pos) {
        var hearts = '';
        var i = 0;
        var minimumSHearts = 3;
        var numOfHearts = minimumSHearts - (pos - 1);

        while (i < numOfHearts) {
            hearts = hearts + '♥︎';
            i++;
        }
        return hearts;
    },

    showFormValidationSummary: function (formId, position) {
        var formErrorCount = $('form#' + formId + ' .form-group.error').length;
        var errorMessage = 'Ups! Da ging was schief! Bitte prüfen Sie diese Angaben:';

        if (position === undefined) {
            position = 'prepend';
        }

        if (formErrorCount > 0) {

            var summaryMarkup = '<div class="form-error-summary" id="#' + formId + '-error-summary">';
            summaryMarkup += '<p>' + errorMessage + '</p><ul id="' + formId + '-error-summary"></ul></div>';

            $('form#' + formId).prepend(summaryMarkup);

            $('form#' + formId + ' .form-group.error').each(function (index) {

                var $formField = $(this).find('input, select, textarea, checkbox, radio');

                var fieldLabel = $(this).find('label').html();
                var fieldSetLegend = $(this).parent().find('legend').html();
                var fieldId = $formField.attr('id');
                var fieldLink = '<div class="error-link" onClick=\"AblCh.scrollToElement(\'#' + fieldId + '\')">' + fieldLabel + '</div>';
                var errorInfo = '<li>' + fieldSetLegend + ' : ' + fieldLink + '</li>';
                $('#' + formId + '-error-summary').append(errorInfo);

            });
        }
    },

    /**
     * split ul into columns
     * credits: https://codepen.io/anon/pen/RodeXb
     */
    splitListInColumns: function(listid,num_cols) {
        //var num_cols = 2,
        //console.log(num_cols);
        container = $(listid),
        listItem = 'li',
        listClass = 'sub-list';
        container.each(function() {
            var items_per_col = new Array(),
                items = $(this).find(listItem),
                min_items_per_col = Math.floor(items.length / num_cols),
                difference = items.length - (min_items_per_col * num_cols);
            for (var i = 0; i < num_cols; i++) {
                if (i < difference) {
                    items_per_col[i] = min_items_per_col + 1;
                } else {
                    items_per_col[i] = min_items_per_col;
                }
            }
            for (var i = 0; i < num_cols; i++) {
                // todo: bug leaves empty (but invisible) ul in dom
                $(this).append($('<ul ></ul>').addClass(listClass));
                for (var j = 0; j < items_per_col[i]; j++) {
                    var pointer = 0;
                    for (var k = 0; k < i; k++) {
                        pointer += items_per_col[k];
                    }
                    $(this).find('.' + listClass).last().append(items[j + pointer]);
                }
            }
        });
    },

    /**
     * Initialize main menu
     */
    initializeDropDownMenu: function () {
        // overlay menu ohne bootstrap
        var menuOpenClassName = 'open';

        $("#menu-overlay > ul > li").hoverIntent(function(event) {
            $('.' + menuOpenClassName).removeClass(menuOpenClassName);
            $(this).addClass(menuOpenClassName);
        }, function(event) {
            $(this).removeClass(menuOpenClassName);
        });

        // DoubleTapToGo für Hauptnavigation
        $( '#menu-overlay > ul > li.sub, #menu-overlay > ul > li.sub > ul > li.sub' ).doubleTapToGo();


        // divide siedlungen into multiple ul
        var menuSiedlungen = $("ul#section-siedlungen");
        //AblCh.splitListInColumns('ul#section-siedlungen',3);
        $('ul#section-siedlungen').hide();

    },

    /**
     * Initialize the Slick slider
     */
    initializeSlickSlider: function() {

        /**
         * http://kenwheeler.github.io/slick/
         * ACHTUNG bug: bei Setting "fade:true" wird bei slidesToShow > 1 nur der erste Eintrag gezeigt.
         */

        // set random start slide
        //var numberOfSlides = $('.visol-slider-single .slider-item').length,
        //var startSlide = Math.floor( Math.random() * numberOfSlides );

        var $visolSlider = $('.visol-slickslider-single .visol-slider-single');
        if ($visolSlider.length) {

          // remove  tabindex from slick slides when init is done
          $visolSlider.on('init', function(event, slick) {
            setTimeout(function() {
              $('.slick-slide').removeAttr('tabindex');
            }, 100);
          });

          $visolSlider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                fade: true,
                cssEase: 'linear',
                pauseOnHover: true,
                lazyLoad: 'ondemand',
            });

          // remove aria-hidden from 'current' slick slides, remove tabindex added by slick on change
          $visolSlider.on('afterChange', function(event, slick, currentSlide, nextSlide) {
            setTimeout(function() {
              $('.slick-slide.slick-current').removeAttr('aria-hidden');
              $('.slick-slide').removeAttr('tabindex');
            }, 100);
          });
          // same for beforeChange
          $visolSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            setTimeout(function() {
              $('.slick-slide.slick-current').removeAttr('aria-hidden');
              $('.slick-slide').removeAttr('tabindex');
            }, 100);
          });
        }

        var $visolSliderBackendNeos = $('.visol-slickslider-single-backend .visol-slider-single');
        if ($visolSliderBackendNeos.length) {
            $visolSliderBackendNeos.slick({
                autoplay: false,
                arrows: true,
                dots: false,
                fade: false,
                slide: '.visol-ablch-slideritem'
            });
        }

        /**
         * singe image slide on top
         * attention: fade:true on top level of settings  breaks responsive
         */
        var $visolScrollBarDetail = $('.visol-scrollbar-detail');
        if ($visolScrollBarDetail.length) {
            $visolScrollBarDetail.slick({
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                dots: false
            })
        }

        /**
         * scrollbar acting as navbar for single image scroller
         */
        var $visolScrollBar = $('.visol-scrollbar');
        if ($visolScrollBar.length) {
            $visolScrollBar.slick({
                autoplay: false,
                slidesToShow: 6,
                slidesToScroll: 6,
                asNavFor: '.visol-scrollbar-detail',
                //centerMode: true,
                focusOnSelect: true,
                dots: true,
                lazyLoad: 'ondemand',

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5,
                            infinite: true,
                            asNavFor: '.visol-scrollbar-detail',
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            infinite: true,
                            asNavFor: '.visol-scrollbar-detail',
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            asNavFor: '.visol-scrollbar-detail',
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            asNavFor: '.visol-scrollbar-detail',
                        }
                    },
                    {
                        breakpoint: 350,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            asNavFor: '.visol-scrollbar-detail',
                        }
                    }
                ],
            })
        }
    },

    /**
     * Initialize custom DL.Gallery bootstrapCarousel
     */
    initializeDlGallerySlider: function () {
      var $dlGallerySlider = $('.dl-gallery.carousel-lightbox .carousel-item');
      if ($dlGallerySlider.length) {
        $('.dl-gallery.carousel-lightbox .carousel-item:first-child').addClass('active');
      }
    }
});

// Must be at the end so it is initialized after mm-menu
require('./proposalPlatform');
require('./magazine');
